/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface IlluminateUser
 */
export interface IlluminateUser {
    /**
     *
     * @type {string}
     * @memberof IlluminateUser
     */
    platformSource?: string;
    /**
     *
     * @type {string}
     * @memberof IlluminateUser
     */
    userType?: IlluminateUserUserTypeEnum;
    /**
     * email address
     * @type {string}
     * @memberof IlluminateUser
     */
    username?: string;
    /**
     *
     * @type {string}
     * @memberof IlluminateUser
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof IlluminateUser
     */
    externalUserId?: string;
    /**
     *
     * @type {string}
     * @memberof IlluminateUser
     */
    externalIdentityKey?: string;
    /**
     *
     * @type {number}
     * @memberof IlluminateUser
     */
    userAccountId?: number;
    /**
     *
     * @type {string}
     * @memberof IlluminateUser
     */
    identityProvider?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof IlluminateUser
     */
    permissions?: Array<IlluminateUserPermissionsEnum>;
    /**
     *
     * @type {Array<string>}
     * @memberof IlluminateUser
     */
    roles?: Array<string>;
    /**
     *
     * @type {string}
     * @memberof IlluminateUser
     */
    organisationId?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof IlluminateUser
     */
    organisationGroups?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof IlluminateUser
     */
    deviceGroupTags?: Array<string>;
    /**
     * Timestamp when user last accepted the terms and conditions
     * @type {Date}
     * @memberof IlluminateUser
     */
    termsAcceptedAt?: Date;
}

/**
 * @export
 */
export const IlluminateUserUserTypeEnum = {
    Unknown: "Unknown",
    EnterpriseUser: "EnterpriseUser",
    EndUser: "EndUser",
    ApiUser: "ApiUser",
    Driver: "Driver",
} as const;
export type IlluminateUserUserTypeEnum =
    (typeof IlluminateUserUserTypeEnum)[keyof typeof IlluminateUserUserTypeEnum];

/**
 * @export
 */
export const IlluminateUserPermissionsEnum = {
    None: "none",
    DeviceLocationRead: "device_location_read",
    DeviceLocationUpdate: "device_location_update",
    DeviceConfigRead: "device_config_read",
    DeviceConfigUpdate: "device_config_update",
    DeviceReset: "device_reset",
    DeviceLogsRead: "device_logs_read",
    DeviceTasksRead: "device_tasks_read",
    DeviceTasksCreate: "device_tasks_create",
    DeviceEnergyUsageRead: "device_energy_usage_read",
    DeviceOperationalUpdate: "device_operational_update",
    DeviceFirmwareUpdate: "device_firmware_update",
    ChargeTransactionsRead: "charge_transactions_read",
    PowerMeterValuesRead: "power_meter_values_read",
    UserTasksRead: "user_tasks_read",
    EnterpriseUserAccountRead: "enterprise_user_account_read",
    EnterpriseUserAccountUpdate: "enterprise_user_account_update",
    EnterpriseUserAccountRoleUpdate: "enterprise_user_account_role_update",
    DeviceGroupManage: "device_group_manage",
    DeviceGroupCreate: "device_group_create",
    DeviceProvisioning: "device_provisioning",
    DevicePassthroughManage: "device_passthrough_manage",
    RfidTagsRead: "rfid_tags_read",
    RfidTagsManage: "rfid_tags_manage",
    RfidTagsDelete: "rfid_tags_delete",
    RoleCreate: "role_create",
    TicketingRead: "ticketing_read",
    TicketingCreate: "ticketing_create",
    PpmRead: "ppm_read",
    PpmManage: "ppm_manage",
    WebhookCreate: "webhook_create",
    NotificationPreferencesRead: "notification_preferences_read",
    NotificationPreferencesManage: "notification_preferences_manage",
    NotificationPreferencesManageOthers:
        "notification_preferences_manage_others",
    OrganisationPreferencesManage: "organisation_preferences_manage",
    MediaManage: "media_manage",
    DnspDashboard: "dnsp_dashboard",
    ProjectDashboard: "project_dashboard",
    GlobalDashboard: "global_dashboard",
    SystemDeviceProvisioning: "system_device_provisioning",
    SystemDeviceDeprovisioning: "system_device_deprovisioning",
    SystemDeviceAccessTagsUpdate: "system_device_access_tags_update",
    SystemDeviceServiceManage: "system_device_service_manage",
    SystemDeviceCatalogueUpdate: "system_device_catalogue_update",
    SystemOrganisation: "system_organisation",
    SystemUserAccountManage: "system_user_account_manage",
    SystemRfidTagsManage: "system_rfid_tags_manage",
    SystemPassthroughManage: "system_passthrough_manage",
    SystemServiceModelManage: "system_service_model_manage",
    SystemVehicleModelManage: "system_vehicle_model_manage",
    DevicePricingRead: "device_pricing_read",
    DevicePricingManage: "device_pricing_manage",
    DeviceDisplayPriceRead: "device_display_price_read",
    DeviceDisplayPriceManage: "device_display_price_manage",
    PartnerDeviceProvisioning: "partner_device_provisioning",
    PartnerOrganisationManage: "partner_organisation_manage",
    SystemE2eTestRunner: "system_e2e_test_runner",
} as const;
export type IlluminateUserPermissionsEnum =
    (typeof IlluminateUserPermissionsEnum)[keyof typeof IlluminateUserPermissionsEnum];

/**
 * Check if a given object implements the IlluminateUser interface.
 */
export function instanceOfIlluminateUser(
    value: object,
): value is IlluminateUser {
    return true;
}

export function IlluminateUserFromJSON(json: any): IlluminateUser {
    return IlluminateUserFromJSONTyped(json, false);
}

export function IlluminateUserFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): IlluminateUser {
    if (json == null) {
        return json;
    }
    return {
        platformSource:
            json["platformSource"] == null ? undefined : json["platformSource"],
        userType: json["userType"] == null ? undefined : json["userType"],
        username: json["username"] == null ? undefined : json["username"],
        name: json["name"] == null ? undefined : json["name"],
        externalUserId:
            json["externalUserId"] == null ? undefined : json["externalUserId"],
        externalIdentityKey:
            json["externalIdentityKey"] == null
                ? undefined
                : json["externalIdentityKey"],
        userAccountId:
            json["userAccountId"] == null ? undefined : json["userAccountId"],
        identityProvider:
            json["identityProvider"] == null
                ? undefined
                : json["identityProvider"],
        permissions:
            json["permissions"] == null ? undefined : json["permissions"],
        roles: json["roles"] == null ? undefined : json["roles"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        organisationGroups:
            json["organisationGroups"] == null
                ? undefined
                : json["organisationGroups"],
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
        termsAcceptedAt:
            json["termsAcceptedAt"] == null
                ? undefined
                : new Date(json["termsAcceptedAt"]),
    };
}

export function IlluminateUserToJSON(value?: IlluminateUser | null): any {
    if (value == null) {
        return value;
    }
    return {
        platformSource: value["platformSource"],
        userType: value["userType"],
        username: value["username"],
        name: value["name"],
        externalUserId: value["externalUserId"],
        externalIdentityKey: value["externalIdentityKey"],
        userAccountId: value["userAccountId"],
        identityProvider: value["identityProvider"],
        permissions: value["permissions"],
        roles: value["roles"],
        organisationId: value["organisationId"],
        organisationGroups: value["organisationGroups"],
        deviceGroupTags: value["deviceGroupTags"],
        termsAcceptedAt:
            value["termsAcceptedAt"] == null
                ? undefined
                : value["termsAcceptedAt"].toISOString(),
    };
}
